import { useState, useRef, useEffect } from "react";

const flags = [
  { value: "en", label: "En", img: "/dist/img/GB.png" },
  { value: "id", label: "Id", img: "/dist/img/ID.png" },
];

export default function LanguageSwitch({ language, setLanguage }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const selected = flags.find((f) => f.value === language) || flags[0];

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="language-switch" ref={ref}>
      <div
        className={`language-switch-btn ${open ? "open" : ""}`}
        onClick={() => setOpen((prev) => !prev)}
      >
        <img src={selected.img} alt={selected.label} width={20} height={14} style={{ objectFit: "cover" }} />
        <span>{selected.label}</span>
        <span className="language-switch-arrow">▾</span>
      </div>

      {open && (
        <ul className="language-switch-dropdown">
          {flags.map((flag) => (
            <li
              key={flag.value}
              className={flag.value === language ? "active" : ""}
              onClick={() => {
                setLanguage(flag.value);
                setOpen(false);
              }}
            >
              <img src={flag.img} alt={flag.label} width={20} height={14} style={{ objectFit: "cover" }} />
              <span>{flag.label}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}